import Navbar from '@/components/feature/Navbar';
import Hero from './components/Hero';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import WhatIsSection from './components/WhatIsSection';
import WhySection from './components/WhySection';
import ResourceCenter from './components/ResourceCenter';
import HowItWorks from './components/HowItWorks';
import SeoContentBlock from './components/SeoContentBlock';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Sugargoo Spreadsheet 2026 - The Ultimate Product Discovery Database",
            "description": "Discover thousands of organized Sugargoo finds, curated product spreadsheets, shopping guides, shipping information, coupon updates and expert reviews — all in one powerful independent resource hub.",
            "url": "https://sugargoosheet.art/",
            "isPartOf": {
              "@type": "WebSite",
              "name": "Sugargoo Sheet",
              "url": "https://sugargoosheet.art/"
            },
            "about": {
              "@type": "Thing",
              "name": "Sugargoo Spreadsheet",
              "description": "A structured product discovery resource that helps shoppers organize products, compare options and find trending items faster."
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Home",
                  "item": "https://sugargoosheet.art/"
                }
              ]
            },
            "mainEntity": {
              "@type": "ItemList",
              "itemListElement": [
                {"@type": "ListItem", "position": 1, "name": "Shoes", "url": "https://kaspreadsheet.com/category-911-Shoes.html"},
                {"@type": "ListItem", "position": 2, "name": "Hoodies & Sweaters", "url": "https://kaspreadsheet.com/search-912/name/Shoes.html"},
                {"@type": "ListItem", "position": 3, "name": "T-Shirts", "url": "https://kaspreadsheet.com/search-913/name/Shoes.html"},
                {"@type": "ListItem", "position": 4, "name": "Jackets", "url": "https://kaspreadsheet.com/search-914/name/Shoes.html"},
                {"@type": "ListItem", "position": 5, "name": "Pants & Shorts", "url": "https://kaspreadsheet.com/search-915/name/Shoes.html"},
                {"@type": "ListItem", "position": 6, "name": "Headwear", "url": "https://kaspreadsheet.com/search-916/name/Shoes.html"},
                {"@type": "ListItem", "position": 7, "name": "Sets", "url": "https://kaspreadsheet.com/search-917/name/Shoes.html"},
                {"@type": "ListItem", "position": 8, "name": "Underwear & Underpants", "url": "https://kaspreadsheet.com/search-918/name/Shoes.html"},
                {"@type": "ListItem", "position": 9, "name": "Jersey", "url": "https://kaspreadsheet.com/search-919/name/Shoes.html"},
                {"@type": "ListItem", "position": 10, "name": "Accessories", "url": "https://kaspreadsheet.com/search-920/name/Shoes.html"},
                {"@type": "ListItem", "position": 11, "name": "Bags", "url": "https://kaspreadsheet.com/search-921/name/Shoes.html"},
                {"@type": "ListItem", "position": 12, "name": "Belts", "url": "https://kaspreadsheet.com/search-922/name/Shoes.html"},
                {"@type": "ListItem", "position": 13, "name": "Perfumes", "url": "https://kaspreadsheet.com/search-923/name/Shoes.html"},
                {"@type": "ListItem", "position": 14, "name": "Other Stuff", "url": "https://kaspreadsheet.com/search-924/name/Shoes.html"}
              ]
            }
          })
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <CategoryDropdown />
        <CategoryGrid />
        <WhatIsSection />
        <WhySection />
        <ResourceCenter />
        <HowItWorks />
        <SeoContentBlock />
      </main>
      <Footer />
    </div>
  );
}